var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResultsActionShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    fill: "#EEF6FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7904 54.1695C20.3657 54.1695 19.2109 53.0146 19.2109 51.59L19.2109 37.1177C19.2109 28.447 26.2399 21.418 34.9106 21.418L36.0161 21.418C44.0762 21.418 50.6103 27.952 50.6103 36.0122C50.6103 46.0402 42.481 54.1695 32.453 54.1695L21.7904 54.1695Z",
    fill: "#5DA5D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.312 54.1695C55.1261 54.1695 55.786 53.5096 55.786 52.6955L55.786 44.4256C55.786 39.4709 51.7694 35.4543 46.8147 35.4543L46.183 35.4543C41.5772 35.4543 37.8435 39.1881 37.8435 43.7939C37.8435 49.5242 42.4888 54.1695 48.2191 54.1695L54.312 54.1695Z",
    fill: "#284993"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultsActionShare);
export default __webpack_public_path__ + "static/media/results-action-share.5f8c9b83cd32fc79b16339ee1c5cda96.svg";
export { ForwardRef as ReactComponent };